import X from '../x.js';
import '../x-item/index.js';

import commonCSS from '../../../css/common.js';

class XInfo extends X {
  render(target) {
    target.innerHTML = `
      <style>
        ${commonCSS}

        :host {
          display: block;
          padding: 2rem;
          color: grey;
        }
      </style>

     <h1>Info</h1>
    `;
  }
}

customElements.define('x-info', XInfo);
